import { render, staticRenderFns } from "./cost-average-modal.vue?vue&type=template&id=488bb72e&scoped=true&"
import script from "./cost-average-modal.vue?vue&type=script&lang=js&"
export * from "./cost-average-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488bb72e",
  null
  
)

export default component.exports